export default {"src":"/_next/static/media/restart_icon.4bb849cf.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};